import PropTypes from 'prop-types';
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PageTopbar.css';

class PageTopbar extends React.Component {
  static propTypes = {
    title: PropTypes.string,
  };

  static defaultProps = {
    title: '',
  };

  render() {
    const { title } = this.props;

    return title ? (
      <div className={s.root}>
        <div className={s.container}>
          <span className={s.title}>{title}</span>
        </div>
      </div>
    ) : null;
  }
}

export default withStyles(s)(PageTopbar);



// WEBPACK FOOTER //
// ./src/components/Page/PageTopbar.js